import { CareType } from '@pflegia/types/api/employer/care-type';
import { EmployerType } from '@pflegia/types/api/employer/employer-type';

export const careTypeToTypeOfEmployer = (careType?: string | null): EmployerType => {
  switch (careType) {
    case CareType.Stationary:
      return EmployerType.NursingHome;
    case CareType.IntensiveAmbulant:
      return EmployerType.IntensiveAmbulant;
    case CareType.IntensiveStationary:
      return EmployerType.Intensive;
    case CareType.Ambulant:
      return EmployerType.Ambulant;
    case CareType.Hospital:
      return EmployerType.Hospital;
    case CareType.Leasing:
      return EmployerType.Leasing;
    case CareType.RehabClinic:
      return EmployerType.RehabClinic;
    case CareType.Hospice:
      return EmployerType.Hospice;
    case CareType.DentalPractice:
      return EmployerType.DentalPractice;
    case CareType.DoctorOffice:
      return EmployerType.DoctorOffice;
    case CareType.Physiotherapy:
      return EmployerType.Physiotherapy;
    case CareType.UniversityHospital:
      return EmployerType.UniversityHospital;
    case CareType.PrivateClinic:
      return EmployerType.PrivateClinic;
    case CareType.MedicalCareCenter:
      return EmployerType.MedicalCareCenter;
    case CareType.OutpatientPractice:
      return EmployerType.OutpatientPractice;
    default:
      return EmployerType.Other;
  }
};
